import React, { useEffect, useState } from "react";
import { GiWallet } from "react-icons/gi";
import "./AddFund.css";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const formatWalletName = (name) =>
  String(name || "")
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const AddFunds = () => {
  const [userName, setUserName] = useState("");
  const [amount, setAmount] = useState("");
  const [fundReason, setFundReason] = useState("");
  const [selectWallet, setSelectWallet] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUserName, setExistUserName] = useState();
  const [incomeData, setIncomeData] = useState([]);
  const token = localStorage.getItem("authToken");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // if (!userName || !amount) {
    //   toast.error("Please fill in all fields");
    //   return;
    // }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
      const { data, error } = await apiCall(
        "post",
        "/add_fund",
        {
          amount: amount,
          username: userName,
          wallet_name: selectWallet,
          note: "Fund added by admin",
        },
        config
      );

      if (data) {
        // toast.success(data?.message || "");
        setUserName("");
        setAmount("");
        setFundReason("");
        setSelectWallet("");
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  const isUserExist = async () => {
    if (!userName) {
      setExistUserName("");
      setChecking(false);
      return;
    }

    setChecking(true);
    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: userName,
      });
      if (data) {
        setExistUserName(data.name);
      } else if (error) {
        setExistUserName("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setChecking(false);
  };

  var x = 0;

  useEffect(() => {
    if (x == 0) {
      fetchWallets();
      x++;
    }
  }, []);

  useEffect(() => {
    // Clear the timeout when the user is typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 500ms debounce delay
    );

    // Cleanup the timeout when the component is unmounted or when typing continues
    return () => clearTimeout(typingTimeout);
  }, [userName]);

  const fetchWallets = async (e) => {
    try {
      const { data, error } = await apiCall("get", "/retrieve_wallet");
      console.log(data, "....");
      setIncomeData(data?.data);
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const userStatus = !userName
    ? "Enter a username to look up the user"
    : checking
      ? "Checking username..."
      : existUserName || "";
  const userStatusClass = !userName
    ? ""
    : checking
      ? "is-loading"
      : existUserName === "User not exists"
        ? "is-error"
        : existUserName
          ? "is-ok"
          : "";

  const resetForm = () => {
    setUserName("");
    setAmount("");
    setFundReason("");
    setSelectWallet("");
  };

  return (
    <section className="add-funds">
      <div className="add-funds__head">
        <h1>Add Funds</h1>
        <p>Credit an amount to a user's wallet.</p>
      </div>

      <form className="add-funds__card" onSubmit={handleSubmit}>
        <div className="add-funds__card-head">
          <span className="add-funds__icon" aria-hidden="true">
            <GiWallet />
          </span>
          <div>
            <h2>Fund transfer</h2>
            <p>Username is checked before the amount is added.</p>
          </div>
        </div>

        <label className="add-funds__field" htmlFor="userName">
          <span>Username</span>
          <input
            type="text"
            id="userName"
            className="form-control"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Enter username"
            required
          />
          {userStatus ? (
            <small className={`add-funds__status ${userStatusClass}`}>{userStatus}</small>
          ) : null}
        </label>

        <label className="add-funds__field" htmlFor="walletType">
          <span>Wallet type</span>
          <select
            id="walletType"
            className="form-control"
            value={selectWallet}
            onChange={(e) => setSelectWallet(e.target.value)}
            required
          >
            <option value="">Select wallet</option>
            {Array.isArray(incomeData) &&
              incomeData.map((wallet, index) => (
                <option key={wallet?.wallet_name || index} value={wallet?.wallet_name}>
                  {formatWalletName(wallet?.wallet_name)}
                </option>
              ))}
          </select>
        </label>

        <label className="add-funds__field" htmlFor="amount">
          <span>Amount</span>
          <input
            type="number"
            id="amount"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            min="0"
            step="any"
            required
          />
        </label>

        <div className="add-funds__actions">
          <button type="submit" className="add-funds__submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
          <button type="button" className="add-funds__cancel" onClick={resetForm}>
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
};

export default AddFunds;
